module.exports = __webpack_public_path__ + "static/media/George B. McClellan - 1864.a31448db.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/us/George B. McClellan - 1864.jpg
// module id = 468
// module chunks = 0